import $ from '@rover/globals/jquery';
import _ from '@rover/globals/underscore';
import Backbone from '@rover/globals/backbone';
import Rover from '@rover/globals/Rover';
import { isMobileEmbedded } from '@rover/utilities/userAgent';

import CreditCardModel from './CreditCardModel';

export default Backbone.Collection.extend({
  model: CreditCardModel,
  initialize(options = {}) {
    _.bindAll(this, 'addNewCC');
    this.closeOnAddNewCC = options.closeOnAddNewCC || false;
  },
  addNewCC({ url }) {
    const newCCModel = new CreditCardModel({ instanceUrl: url });
    const that = this;

    that.closeMobileEmbedded();

    newCCModel.fetch({
      success(model, creditCard) {
        that.add(new CreditCardModel(creditCard));
      },
    });
  },
  closeMobileEmbedded() {
    if (isMobileEmbedded() && this.closeOnAddNewCC) {
      if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.rover &&
        window.webkit.messageHandlers.rover.postMessage
      ) {
        window.webkit.messageHandlers.rover.postMessage({
          action: 'dialog-closed',
        });
      } else {
        $(document).trigger({ type: 'dialog-closed' });
      }
    }
  },
});



// WEBPACK FOOTER //
// ./js/backbone/models/CreditCardCollection.js